import { CROP_ZONE_TAGS_FIELD } from '../../NewEditCropZone/components/CropZoneTagsSection/constants';

type CropZoneFormValues = Record<string, unknown> & { id?: string };

const getCropZoneBody = (
  values: CropZoneFormValues
): Record<string, unknown> => {
  if (values.id === undefined) return {};

  const selectedCropSeasons = JSON.parse(
    localStorage.getItem('selectedCropSeasons') as string
  );

  const body: Record<string, unknown> = {
    ...values,
    cropSeasonId: selectedCropSeasons[0],
    geometry: values?.geometry ?? {},
    reportedArea: values?.reportedArea ?? 0,
    tags: values?.[CROP_ZONE_TAGS_FIELD] ?? []
  };

  delete body.dateEpoch;
  // The form names this field `tagIds` for consistency with every other form here,
  // while the API expects `tags`, so the form-only key must not reach it.
  delete body[CROP_ZONE_TAGS_FIELD];

  return body;
};

export default getCropZoneBody;
